<!-- <li class="panel"> -->
<ng-template [ngIf]="entity">
<div class="controparte">
	<div>
		<p class="col-sm-2">
			<button (click)="emitEntity(entity)" class="btn btn-primary associa"
				type="submit">Allega</button>
		</p>
    <h4 class="titolo col-sm-3">
      {{entity.parte?.nominativo}}
    </h4>

		<ng-template [ngIf]="entity.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
		<p class="col-sm-3 matricola">
			C/F: <strong> {{ entity.parte.codiceFiscale }} </strong>
		</p>
		</ng-template>
		<ng-template
			[ngIf]="entity.parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
		<p class="col-sm-3 matricola">
			P.IVA: <strong> {{ entity.parte.partitaIva }} </strong>
		</p>
		</ng-template>
		<p class="col-sm-3 matricola">
			MAT: <strong></strong>
		</p>
		<p class="col-sm-1 matricola">
			Primaria: <strong>{{ entity.primario ? 'Si' : 'No' }}</strong>
		</p>
	</div>
</div>
</ng-template>
<!-- </li> -->
